import { render, staticRenderFns } from "./Sdg05.vue?vue&type=template&id=b4a09d82&scoped=true&"
import script from "./Sdg05.vue?vue&type=script&lang=js&"
export * from "./Sdg05.vue?vue&type=script&lang=js&"
import style0 from "./Sdg05.vue?vue&type=style&index=0&id=b4a09d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a09d82",
  null
  
)

export default component.exports